import { Action } from 'redux';

import { TThunkAction } from '../../types/redux';
import { FILTERS_SET_BEDROOMS_COUNT_TYPE } from '../../constants/action_types';
import { getMeta } from './getMeta';

export type TSetBedroomsCountType = 'filters/set_bedrooms_count';

export interface ISetBedroomsCount extends Action<TSetBedroomsCountType> {
  type: TSetBedroomsCountType;
  bedroomsCount: number | null;
}

export type TSetBedroomsCount = ISetBedroomsCount;

export function setBedroomsCount(bedroomsCount: number | null): TThunkAction {
  return dispatch => {
    dispatch<TSetBedroomsCount>({
      type: FILTERS_SET_BEDROOMS_COUNT_TYPE,
      bedroomsCount,
    });

    dispatch(getMeta());
  };
}
